export const getUrlParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return {
    resumeId: urlParams.get("resumeId"),
    jobDescriptionId: urlParams.get("jobDescriptionId"),
    interviewId: urlParams.get("interviewId"),
  };
};
